import React, { useCallback, useContext, useState } from 'react';
import { observer } from 'mobx-react';
import '../../../../../scss/neurosales/common/cmsTopBar.scss';
import { SettingsContext } from './NeurosalesSettings';
import ButtonGroup from '../../../../generic/inputs/simpleComponents/ButtonGroup';
import ColorPicker from '../../../../generic/inputs/simpleComponents/ColorPicker';
import CMSButton from '../../../../generic/inputs/CMSButton';
import Select from '../../../../generic/inputs/simpleComponents/Select';
import RadioButtons from '../../../../generic/inputs/simpleComponents/RadioButtons';
import CMSFileInput from '../../../../generic/inputs/CMSFileInput';
import CMSTextInput from '../../../../generic/inputs/CMSTextInput';
const SingleColorSelector = observer(({
  name = '',
  field = '',
  updateColor,
  component,
  settings
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "settings-item single-line"
  }, /*#__PURE__*/React.createElement("span", {
    className: "main-description"
  }, name), /*#__PURE__*/React.createElement(ColorPicker, {
    color: component.colors[field] ? component.colors[field] : settings.config.colors[field],
    onUpdate: newColor => {
      updateColor(field, newColor);
    }
  }));
});
const SingleFontSelector = observer(({
  name = '',
  field = '',
  updateFont,
  component,
  settings,
  allFonts
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "settings-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "main-description"
  }, name), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, {
    elements: allFonts.map(font => {
      return {
        label: font.name,
        value: font.name
      };
    }),
    defaultValue: component.fonts[field] ? component.fonts[field] : settings.config.fonts[field],
    onChangeSelect: newFont => {
      updateFont(field, newFont);
    }
  })));
});
const SingleDesignSelector = observer(({
  name = '',
  field = '',
  updateDesign,
  component,
  settings
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "settings-item design-settings"
  }, /*#__PURE__*/React.createElement("div", {
    className: "main-description"
  }, name), /*#__PURE__*/React.createElement("div", {
    className: "radio-container-design"
  }, /*#__PURE__*/React.createElement(RadioButtons, {
    elements: [{
      label: 'Bordo squadrato',
      value: 'squared'
    }, {
      label: 'Bordo stondato - 50%',
      value: 'round50'
    }, {
      label: 'Bordo stondato - 100%',
      value: 'round100'
    }],
    defaultValue: component.design[field] ? component.design[field] : settings.config.design[field],
    onChangeRadio: newValue => {
      updateDesign(field, newValue);
    },
    renderElement: e => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, e.label), /*#__PURE__*/React.createElement("span", {
        className: `design-elem design--${e.value}`
      }));
    }
  })));
});
const DisambiguationUploadSelector = observer(({
  field = '',
  component
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "settings-item"
  }, /*#__PURE__*/React.createElement(CMSFileInput, {
    title: "Icona disambiguazione",
    supportedFiles: ['svg'],
    minDimension: 150,
    minWidth: 1500,
    minHeight: 1500,
    buttonText: "Carica l'icona",
    baseObj: component.design,
    field: field,
    path: 'settings/'
  }));
});
const DisambiguationUrlSelector = observer(({
  field = '',
  component
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "settings-item"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CMSTextInput, {
    title: "Link disambiguazione",
    description: `Inserisci link alla pagina di disambiguazione`,
    baseObj: component.design,
    placeholder: "https://...",
    field: field
  })));
});
const NeurosalesSettingsSetter = observer(({
  component,
  allFonts
}) => {
  const settings = useContext(SettingsContext);
  const [currentMenu, setCurrentMenu] = useState('color');
  const updateColor = useCallback((field, color) => {
    const newConfig = {
      ...settings.config
    };
    newConfig.colors[field] = color;
    settings.updateConfig(newConfig);
    if (!component.colors) {
      component.colors = {};
    }
    component.colors[field] = color;
  }, [settings, component]);
  const updateFont = useCallback((field, font) => {
    const newConfig = {
      ...settings.config
    };
    newConfig.fonts[field] = font;
    settings.updateConfig(newConfig);
    if (!component.fonts) {
      component.fonts = {};
    }
    component.fonts[field] = font;
  }, [settings, component]);
  const updateDesign = useCallback((field, design) => {
    const newConfig = {
      ...settings.config
    };
    newConfig.design[field] = design;
    settings.updateConfig(newConfig);
    if (!component.design) {
      component.design = {};
    }
    component.design[field] = design;
  }, [settings, component]);
  return /*#__PURE__*/React.createElement("div", {
    className: "cms-settings-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "top-bar-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "top-bar-title-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon settings"
  }), /*#__PURE__*/React.createElement("span", {
    className: "top-bar-title"
  }, "Settings")), /*#__PURE__*/React.createElement("div", {
    className: "settings-top-bar-switcher-container"
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    elements: [{
      label: 'Colori',
      value: 'color'
    }, {
      label: 'Font',
      value: 'font'
    }, {
      label: 'Design',
      value: 'design'
    }],
    onClick: newValue => {
      setCurrentMenu(newValue);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "settings-menu-container"
  }, currentMenu === 'color' ? /*#__PURE__*/React.createElement("div", {
    className: "settings-menu color-settings"
  }, /*#__PURE__*/React.createElement(SingleColorSelector, {
    name: "Colore primario",
    field: "primaryColor",
    settings: settings,
    component: component,
    updateColor: updateColor
  }), /*#__PURE__*/React.createElement(SingleColorSelector, {
    name: "Colore secondario",
    field: "secondaryColor",
    settings: settings,
    component: component,
    updateColor: updateColor
  }), /*#__PURE__*/React.createElement(SingleColorSelector, {
    name: "Background",
    field: "backgroundColor",
    settings: settings,
    component: component,
    updateColor: updateColor
  }), /*#__PURE__*/React.createElement(SingleColorSelector, {
    name: "Colore testo",
    field: "textColor",
    settings: settings,
    component: component,
    updateColor: updateColor
  }), /*#__PURE__*/React.createElement(SingleColorSelector, {
    name: "Colore testo pulsante",
    field: "textColorButton",
    settings: settings,
    component: component,
    updateColor: updateColor
  })) : null, currentMenu === 'font' ? /*#__PURE__*/React.createElement("div", {
    className: "settings-menu font-settings"
  }, /*#__PURE__*/React.createElement(SingleFontSelector, {
    name: "Scegli il font primario",
    field: "primaryFont",
    settings: settings,
    component: component,
    updateFont: updateFont,
    allFonts: allFonts
  }), /*#__PURE__*/React.createElement(SingleFontSelector, {
    name: "Scegli il font secondario (opzionale)",
    field: "secondaryFont",
    settings: settings,
    component: component,
    updateFont: updateFont,
    allFonts: allFonts
  })) : null, currentMenu === 'design' ? /*#__PURE__*/React.createElement("div", {
    className: "settings-menu design-settings"
  }, /*#__PURE__*/React.createElement(SingleDesignSelector, {
    name: "Tipologia pulsante",
    field: "buttonType",
    settings: settings,
    component: component,
    updateDesign: updateDesign
  }), /*#__PURE__*/React.createElement(DisambiguationUploadSelector, {
    field: "disambiguationIcon",
    settings: settings,
    component: component,
    updateDesign: updateDesign
  }), /*#__PURE__*/React.createElement(DisambiguationUrlSelector, {
    field: "disambiguationUrl",
    settings: settings,
    component: component,
    updateDesign: updateDesign
  })) : null), /*#__PURE__*/React.createElement("div", {
    className: "settings-action-buttons-container"
  }, /*#__PURE__*/React.createElement(CMSButton, {
    id: "settings-cancel-button",
    inverted: true,
    onClick: () => {
      settings.resetSettings();
    }
  }, "Annulla"), /*#__PURE__*/React.createElement(CMSButton, {
    disabled: !settings.valid(),
    onClick: () => {
      settings.confirmSettings();
    }
  }, "Salva")));
});
export default NeurosalesSettingsSetter;